module.exports = __webpack_public_path__ + "img/Feature.249b847a.png";